export default __webpack_public_path__ + "static/media/close.e6f45f16.svg";